import React from 'react'

export default function register() {
  return (
    <div className='container'>
      <h1 >Registration page</h1>
      yes you will be able to sign up and sign in👌
    </div>
      
        
  )
}
